import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import TR from './../Trans';
import messageStore from './message';
import { persist, createJSONStorage } from 'zustand/middleware';
import { decades } from './../common/decades';
import { subscribeWithSelector } from 'zustand/middleware';
import accountStore from './account';
import navigationStore from './navigation';
import { generateId } from '../services/random';

const initialState = {
  isSet: false,
  isInitialized: false,
  isWaiting: false,
  isRetrieved: false,
  isWaitingInitial: false,
  isAllLanguageFiltersSet: true,
  isAllGenreFiltersSet: true,
  isAllDecadeFiltersSet: true,
  isAllAlphabetFiltersSet: true,
  filterLanguages: {},
  filterGenres: {},
  filterDecades: {},
  filterAlphabets: {},
  totalCount: 0,
  currentPage: 1,
  pointer: 0,
  previousTrack: null,
  currentTrack: null,
  nextTrack: null,
  tracks: [],
  isPlaying: { isPlaying: false, triggerFade: false },
  isPaused: { isPaused: true, triggerFade: false },
  isMusicOn: false,
  currentTime: 0,
  currentBuffer: 0,
  from: 0,
  currentVolume: 0,
  fadeVolume: 0,
  setterVolume: 0,
  streamUrl: "",
  isTrackLogSent: { isTrackLogSent: false },
  isSaveable: false,
  isSaving: false,
  totalCountSaveable: null,
  isFading: false,
  latestReqId: -1,
  latestReqSaveableId: -1,
  cmdInWaiting: null
};

const musicStore = create(subscribeWithSelector(
  (set, get) => ({
    ...initialState,
    reset: () => {
      set(initialState);
    },
    setCmdInWaiting: (cmd) => {
      set({ cmdInWaiting: cmd });
    },
    setIsInitialized: (isInitialized) => {
      set({ isInitialized: isInitialized });
    },
    setIsFading: (isFading) => {
      set({ isFading: isFading });
    },
    setIsSaveable: (isSaveable) => {
      set({ isSaveable: isSaveable });
    },
    setCurrentBuffer: (buffer) => {
      set({ currentBuffer: buffer });
    },
    setIsTrackLogSent: (isSent) => {
      set({ isTrackLogSent: { isTrackLogSent: isSent } });
    },
    setIsMusicOn: (isOn) => {
      set({ isMusicOn: isOn });
    },
    setIsSaving: (isSaving) => {
      set({ isSaving: { isSaving: isSaving } });
    },
    emptyFilter: () => {
      set({
        isAllLanguageFiltersSet: true,
        isAllGenreFiltersSet: true,
        isAllDecadeFiltersSet: true,
        isAllAlphabetFiltersSet: true,
        filterLanguages: {},
        filterGenres: {},
        filterDecades: {},
        filterAlphabets: {},
      });
    },
    empty: () => {
      console.log("empty(): tracks");
      set({ isSet: false, isPlaying: { isPlaying: false }, isPaused: { isPaused: true }, previousTrack: null, nextTrack: null, tracks: [], streamUrl: "", totalCount: 0, totalCountSaveable: null, currentTime: 0, pointer: 0, isSaveable: false });
    },
    trackEnded: (sessionToken) => {
      if (get().currentTrack) {
        if (get().currentTime >= 30) {
          //console.log(get().currentTrack);
          MuvikaService.setTrackLog(sessionToken, get().currentTrack, 0, 0)
            .then(function (res) {
              if (res.data.error) {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            })
            .catch(function () { });
        }
      }
    },
    getStreamUrl: (sessionToken, track, profile, isPaused = false) => {
      MuvikaService.getStreamUrl(sessionToken, track.track_id, 0, "normal")
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            set({ streamUrl: "" });
            if (res.data.error.code == 9) {
              get().toNext(sessionToken, profile, 25);
            } else {
              console.log("getStreamUrl: getStreamUrl");
              setTimeout(() => get().getStreamUrl(sessionToken, track, profile), 5000);
            }
          } else {
            set({ isSet: true, currentTrack: track, currentTime: 0, streamUrl: res.data.data.url, isWaiting: false });
          }
        })
        .catch(function () { });
    },
    setCurrentTime: (time) => {
      set({ currentTime: time });
    },
    setIsPlaying: (isPlaying, triggerFade = true) => {
      set({ isPlaying: { isPlaying: isPlaying, triggerFade: triggerFade } });
    },
    setIsPaused: (isPaused, triggerFade = true) => {
      set({ isPaused: { isPaused: isPaused, triggerFade: triggerFade } });
    },
    setFrom: (from) => {
      set({ from: { from: from } });
    },
    setVolume: (volume) => {
      set({ currentVolume: volume, fadeVolume: volume });
    },
    setFadeVolume: (volume) => {
      set({ fadeVolume: volume });
    },
    setSetterVolume: (volume) => {
      set({ setterVolume: volume });
    },
    getSaveableTrackCount: (sessionToken) => {
      set({ currentPage: 1, isWaiting: true, totalCountSaveable: null });
      let orderBy = "random";
      let langFilters = get().isAllLanguageFiltersSet ? [] : get().filterLanguages;
      let genreFilters = get().isAllGenresFiltersSet ? [] : get().filterGenres;
      let decadeFilters = get().isAllDecadeFiltersSet ? [] : get().filterDecades;
      let items = MuvikaService.createMusicParameters(
        langFilters,
        genreFilters,
        decadeFilters
      );
      MuvikaService.getTracksForMusic(sessionToken, 1, 1, items, orderBy)
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            set({ isWaiting: false });
          } else {
            let latestReqSaveableId = get().latestReqSaveableId;
            let newReqId = res.data.request_id;
            console.log("RequestIds: " + newReqId + " " + latestReqSaveableId);
            if (newReqId > latestReqSaveableId) {
              set({ totalCountSaveable: res.data.data.items_total, isWaiting: false, latestReqSaveableId: newReqId });
            }
          }
        })
        .catch(function () { });
    },
    isInGenres: (track) => {
      console.log(track);
      let isAllLanguageFiltersSet = get().isAllLanguageFiltersSet;
      let isAllGenresFiltersSet = get().isAllGenreFiltersSet;
      let isAllDecadesFiltersSet = get().isAllDecadeFiltersSet;
      var isLang = true;
      var isGenre = true;
      var isDecade = true;
      if (!isAllLanguageFiltersSet) {
        let langFilters = get().filterLanguages;
        console.log(langFilters);
        console.log(track.language_id);
        isLang = langFilters[track.language_id];
      }
      if (!isAllGenresFiltersSet) {
        isGenre = false;
        let genreFilters = get().filterGenres;
        console.log(genreFilters);
        console.log(track.genre_ids);
        if (track.genre_ids) {
          track.genre_ids.forEach((genre) => {

            if (genreFilters[genre]) {
              isGenre = true;
              console.log(isGenre);
            }
          });
        }
      }
      if (!isAllDecadesFiltersSet) {
        let decadeFilters = get().filterDecades;
        console.log(decadeFilters);
        console.log(track.year);
        let decade = decades.find(x => {
          if (track.year >= x.start && track.year <= x.end) {
            return x;
          }
        });
        console.log(decade);
        isDecade = decade ? decadeFilters[decade.start] ? true : false : false;
      }
      return isLang && isDecade && isGenre;
    },
    getMusicList: (sessionToken, profile) => {
      set({ isWaitingInitial: true });
      let langFilters = {};
      let genreFilters = {};
      let decadeFilters = {};
      MuvikaService.getMusicList(sessionToken)
        .then(function (res) {
          if (res.data.error) {
            set({ isWaitingInitial: false });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            let criteria = res.data.data.criteria;
            if (criteria) {
              let items = criteria.items;
              if (items) {
                items.forEach((arr) => {

                  arr.forEach((criteria) => {

                    switch (criteria.key) {
                      case "language_id":
                        langFilters[criteria.value] = true;
                        break;
                      case "genre_id":
                        genreFilters[criteria.value] = true;
                        break;
                      case "decade":
                        decadeFilters[criteria.value] = true;
                        break;
                    }
                  });
                });
              }
            }
            let tracks = [];
            let trackItems = res.data.data.items;
            if (trackItems) {
              trackItems.forEach((trackItem) => {

                tracks.push(trackItem.track);
              });
            }
            let isAllLanguageFiltersSet = true;
            let isAllGenreFiltersSet = true;
            let isAllDecadeFiltersSet = true;
            Object.keys(langFilters).forEach((key) => {

              if (langFilters[key]) {
                isAllLanguageFiltersSet = false;
              }
            });
            Object.keys(genreFilters).forEach((key) => {

              if (genreFilters[key]) {
                isAllGenreFiltersSet = false;
              }
            });
            Object.keys(decadeFilters).forEach((key) => {

              if (decadeFilters[key]) {
                isAllDecadeFiltersSet = false;
              }
            });
            if (tracks.length > 2) {
              console.log("getMusicList(): tracks > 2");
              set({
                currentTrack: { ...tracks[0] },
                nextTrack: { ...tracks[1] },
                isSet: true,
                isAllLanguageFiltersSet: isAllLanguageFiltersSet,
                isAllGenreFiltersSet: isAllGenreFiltersSet,
                isAllDecadeFiltersSet: isAllDecadeFiltersSet,
                filterLanguages: langFilters,
                filterGenres: genreFilters,
                filterDecades: decadeFilters,
                tracks: tracks,
                isRetrieved: true,
                isWaitingInitial: false
              });
              console.log("getMusicList: getStreamUrl");
              get().getStreamUrl(sessionToken, tracks[0], profile);
            } else {
              console.log("getMusicList(): tracks");
              set({
                isSet: true,
                isAllLanguageFiltersSet: isAllLanguageFiltersSet,
                isAllGenreFiltersSet: isAllGenreFiltersSet,
                isAllDecadeFiltersSet: isAllDecadeFiltersSet,
                filterLanguages: langFilters,
                filterGenres: genreFilters,
                filterDecades: decadeFilters,
                tracks: tracks,
                isRetrieved: true,
                isWaitingInitial: false
              });
            }
            get().getSaveableTrackCount(sessionToken);
          }
        })
        .catch(function () { });
    },
    emptyMusicList: (sessionToken) => {
      MuvikaService.setMusicList(sessionToken, [], {
        items: [[
          {
            key: "media_type",
            value: "music"
          }
        ]]
      })
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          }
        })
        .catch(function () { });
    },
    setMusicList: (sessionToken, profile, tracks, showSavedMessage = true, callbackSuccess, callbackError) => {
      let langFilters = get().isAllLanguageFiltersSet ? [] : get().filterLanguages;
      let genreFilters = get().isAllGenresFiltersSet ? [] : get().filterGenres;
      let decadeFilters = get().isAllDecadeFiltersSet ? [] : get().filterDecades;
      let criteria = {
        items: MuvikaService.createMusicParameters(
          langFilters,
          genreFilters,
          decadeFilters
        )
      };

      let currentTracks = tracks;

      let items = [];
      let dateNow = new Date();
      dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
      currentTracks.forEach((track) => {

        items.push([
          track.track_id,
          profile.id,
          0,
          dateNow.toString(),
          false,
          generateId(8),
          ""
        ]);
      });
      MuvikaService.setMusicList(sessionToken, items, criteria)
        .then(function (res) {
          if (res.data.error) {
            if (callbackError) {
              callbackError();
            }
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            if (callbackSuccess) {
              callbackSuccess();
            }
          }
        })
        .catch(function (err) {
          console.log("tracks", err);
        });
    },
    getTracks: (sessionToken, pageSize, profile) => {
      set({ currentPage: 1, isWaiting: true, isSaveable: false, totalCountSaveable: null });
      navigationStore.setState({ paddingBottoms: {} });
      let orderBy = "random";
      let langFilters = get().isAllLanguageFiltersSet ? [] : get().filterLanguages;
      let genreFilters = get().isAllGenresFiltersSet ? [] : get().filterGenres;
      let decadeFilters = get().isAllDecadeFiltersSet ? [] : get().filterDecades;
      let items = MuvikaService.createMusicParameters(
        langFilters,
        genreFilters,
        decadeFilters
      );
      MuvikaService.getTracksForMusic(sessionToken, pageSize, 1, items, orderBy)
        .then(function (res) {
          //console.log(res);
          if (res.data.error) {
            console.log("getTracks() err: tracks");
            set({ isSet: false, tracks: [], currentTrack: null, nextTrack: null, totalCount: 0, isWaiting: false, isSaving: false });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            let latestReqId = get().latestReqId;
            let newReqId = res.data.request_id;
            if (newReqId > latestReqId) {
              let pointer = get().pointer;
              let currentTracks = get().tracks;
              let oldTracks = [];
              for (let i = 0; i < pointer; i++) {
                if (currentTracks[i]) {
                  oldTracks.push(currentTracks[i]);
                }
              }
              let tracks = res.data.data.items;
              console.log("new tracks", tracks.length, get().currentTrack);
              if (tracks.length > 2) {
                let isCurrentTrackInFilters = false;
                let currentTrack = get().currentTrack;
                //console.log(currentTrack);
                if (currentTrack) {
                  if (get().isInGenres(currentTrack)) {
                    console.log("is in genres");
                    isCurrentTrackInFilters = true;
                    tracks[0] = currentTrack;
                  } else {
                    set({ currentTrack: tracks[0] });
                  }
                } else {
                  set({ currentTrack: tracks[0] });
                }
                set({ nextTrack: tracks[1] });
                if (!isCurrentTrackInFilters) {
                  console.log("getTracks: getStreamUrl");
                  get().getStreamUrl(sessionToken, tracks[0], profile);
                }
                console.log("tracks", tracks);
                tracks = oldTracks.concat(tracks);
                console.log("tracks", tracks);
                get().setMusicList(sessionToken, profile, tracks, true, () => {
                  console.log("setMusicList(): succ tracks > 2");
                  set({ isSet: true, tracks: tracks, totalCountSaveable: null, totalCount: res.data.data.items_total, isWaiting: false, latestReqId: newReqId, isSaving: false });
                }, () => {
                  console.log("setMusicList(): err tracks > 2");
                  set({ isSet: false, currentTrack: null, totalCountSaveable: null, nextTrack: null, tracks: [], totalCount: 0, isWaiting: false, isSaving: false });
                });
              } else {
                get().setMusicList(sessionToken, profile, [], true, () => {
                  console.log("setMusicList(): succ tracks");
                  set({ currentTrack: null, nextTrack: null, totalCountSaveable: null, isSet: true, tracks: [], totalCount: 0, isWaiting: false, latestReqId: newReqId, streamUrl: "", isSaving: false });
                }, () => {
                  console.log("setMusicList(): err tracks");
                  set({ isSet: false, currentTrack: null, totalCountSaveable: null, nextTrack: null, tracks: [], totalCount: 0, isWaiting: false, isSaving: false });
                });
              }
            }
          }
        })
        .catch(function (err) {
          set({ isSet: false, tracks: [], currentTrack: null, nextTrack: null, totalCountSaveable: null, totalCount: 0, isWaiting: false, isSaving: false });
        });
    },
    getTracksMore: (sessionToken, pageSize, profile) => {
      //console.log("get more");
      if (!get().isWaiting) {
        let page = get().currentPage + 1;
        set({ currentPage: page, isSet: false, isWaiting: true });
        let orderBy = "random";
        let langFilters = get().isAllLanguageFiltersSet ? [] : get().filterLanguages;
        let genreFilters = get().isAllGenresFiltersSet ? [] : get().filterGenres;
        let decadeFilters = get().isAllDecadeFiltersSet ? [] : get().filterDecades;
        let items = MuvikaService.createMusicParameters(
          langFilters,
          genreFilters,
          decadeFilters
        );
        MuvikaService.getTracksForMusic(sessionToken, pageSize, page, items, orderBy)
          .then(function (res) {
            //console.log(res);
            if (res.data.error) {
              console.log("getTracksMore(): err tracks");
              set({ isSet: false, tracks: [], totalCount: 0, isWaiting: false });
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              let latestReqId = get().latestReqId;
              let newReqId = res.data.request_id;
              if (newReqId > latestReqId) {
                let tracks = get().tracks;
                let pointer = get().pointer;
                let nextTracks = [];
                for (let i = pointer; i < tracks.length; i++) {
                  if (tracks[i]) {
                    nextTracks.push(tracks[i]);
                  }
                }
                let moreTracks = res.data.data.items;
                tracks = tracks.concat(moreTracks);
                if (moreTracks.length > 0) {
                  set({ nextTrack: moreTracks[0] });
                } else {
                  set({ nextTrack: null });
                }
                console.log("getTracksMore(): tracks");
                set({ isSet: true, tracks: tracks, totalCount: res.data.data.items_total, isWaiting: false, latestReqId: newReqId });
                get().setMusicList(sessionToken, profile, nextTracks.concat(moreTracks));
              }
            }
          })
          .catch(function () { });
      }
    },
    toPrevious: (sessionToken, profile) => {
      let pointer = get().pointer;
      let tracks = get().tracks;
      let prevTrack = tracks[pointer - 2] ? tracks[pointer - 2] : null;
      let currentTrack = tracks[pointer - 1] ? tracks[pointer - 1] : null;
      let nextTrack = tracks[pointer] ? tracks[pointer] : null;
      if (pointer - 1 >= 0) {
        set({ previousTrack: prevTrack, currentTrack: currentTrack, nextTrack: nextTrack, pointer: pointer - 1 });
        console.log("toPrevious: getStreamUrl");
        get().getStreamUrl(sessionToken, currentTrack, profile);
        let newTracks = [];
        for (let i = pointer - 1; i < tracks.length; i++) {
          newTracks.push(tracks[i]);
        }
        get().setMusicList(sessionToken, profile, newTracks);
      }
    },
    toNext: (sessionToken, profile, pageSize) => {
      let pointer = get().pointer;
      let tracks = get().tracks;
      if (pointer + 2 < tracks.length) {
        let prevTrack = tracks[pointer] ? tracks[pointer] : null;
        let currentTrack = tracks[pointer + 1] ? tracks[pointer + 1] : null;
        let nextTrack = tracks[pointer + 2] ? tracks[pointer + 2] : null;
        set({ previousTrack: prevTrack, currentTrack: currentTrack, nextTrack: nextTrack, pointer: pointer + 1 });
        console.log("toNext: getStreamUrl");
        get().getStreamUrl(sessionToken, currentTrack, profile);
        let newTracks = [];
        for (let i = pointer + 1; i < tracks.length; i++) {
          newTracks.push(tracks[i]);
        }
        get().setMusicList(sessionToken, profile, newTracks);
      } else {
        get().getTracksMore(sessionToken, pageSize);
      }
    },
    setPreviousTrack: (track) => {
      set({ previousTrack: track });
    },
    setNextTrack: (track) => {
      set({ nextTrack: track });
    },
    setCurrentTrack: (track) => {
      set({ currentTrack: track });
    },
    setLanguageFilter: (id, isOn) => {
      let filterLanguages = get().filterLanguages;
      filterLanguages[id] = isOn;
      let isAllLanguageFiltersSet = true;
      for (const [key, value] of Object.entries(filterLanguages)) {
        if (value) {
          isAllLanguageFiltersSet = false;
        }
      }
      set({ isAllLanguageFiltersSet: isAllLanguageFiltersSet, filterLanguages: { ...filterLanguages } });
    },
    setAllLanguageFilters: (trackLanguages) => {
      let filterLanguages = {};
      trackLanguages.forEach(function (lang) {
        filterLanguages[lang.id] = false;
      });
      set({ isAllLanguageFiltersSet: true, filterLanguages: filterLanguages });
    },
    setGenreFilter: (id, isOn) => {
      let filterGenres = get().filterGenres;
      filterGenres[id] = isOn;
      let isAllGenreFiltersSet = true;
      for (const [key, value] of Object.entries(filterGenres)) {
        if (value) {
          isAllGenreFiltersSet = false;
        }
      }
      set({ isAllGenreFiltersSet: isAllGenreFiltersSet, filterGenres: { ...filterGenres } });
    },
    setAllGenreFilters: (trackGenres) => {
      let filterGenres = {};
      trackGenres.forEach(function (genre) {
        filterGenres[genre.id] = false;
      });
      set({ isAllGenreFiltersSet: true, filterGenres: filterGenres });
    },
    setDecadeFilter: (id, isOn) => {
      let filterDecades = get().filterDecades;
      filterDecades[id] = isOn;
      let isAllDecadeFiltersSet = true;
      for (const [key, value] of Object.entries(filterDecades)) {
        if (value) {
          isAllDecadeFiltersSet = false;
        }
      }
      set({ isAllDecadeFiltersSet: isAllDecadeFiltersSet, filterDecades: { ...filterDecades } });
    },
    setAllDecadeFilters: (trackDecades) => {
      let filterDecades = {};
      trackDecades.forEach(function (decade) {
        filterDecades[decade] = false;
      });
      set({ isAllDecadeFiltersSet: true, filterDecades: filterDecades });
    }
  }
  ))
);

export default musicStore;